import { useEffect } from 'react';

let locks = 0;
/** Ref-counted page scroll lock (for sheets and dialogs). */
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    locks += 1;
    document.documentElement.style.overflow = 'hidden';
    return () => {
      locks -= 1;
      if (locks <= 0) {
        locks = 0;
        document.documentElement.style.overflow = '';
      }
    };
  }, [active]);
}
